import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { getFormValues, reduxForm, reset, touch } from 'redux-form';
import { Col, FormContainer, Row, ParentContainer } from '../styles';
import {
  scrollToError,
  activateLoader,
  disableLoader
} from '../../../../../redux/actions/ui-trigger/ui-trigger-action';
import { UPLOAD_DOC_FORM, EU_REGION, MY, US, FORMNAME_RFI } from '../../../../../utils/constants';
import {
  changeOnBoardingScreen,
  getIndividualDocumentsUploadList
} from '../../../../../redux/actions/onboarding/new-onboarding-action';
import {
  Header,
  RFIUploadHeader,
  RFIUploadHeaderContainer,
  RFIUploadSubHeader,
  SubContainer,
  SubHeader
} from './styles';
import {
  getFilteredDocList,
  getFilteredDocListUS,
  handleSubmitDocs,
  logEvents,
  uploadConstants,
  CorridorSpecificCMSData
} from './utils';
import { ManualDocumentFields } from './manualDocumentFields';
import { FilesErrorTypes, IManualDocumentUpload } from '../Interfaces/interface';
import { getContentSchemaFromContentFul } from '../../../../../redux/actions/common/common-action';
import { REVAMPED_SCREENS } from '../utils/constants';
import { getContentCountryCode } from '../utils/Util';
import CommonButton from '../../../../../components/common-button/CommonButton';
import { CHEVRON_LEFT_ICON } from '@Images';
import { store } from '../../../../../store';
import { submitSgKycRfi } from '../../../../RFI/singpass-ekyc/utils';
import { ImgFileType } from '../../../../RFI/singpass-ekyc/types';
import { getSgkycFlowRfiData } from '@Redux/selectors';
import { SG_ODD_FLOW_TYPES } from '../../../../RFI/singpass-ekyc/ScreenConstants';
import { uploadDocDetailsNew } from '@Redux/actions/individual-user-flow/individual-user-flow-action';
import { processSubmitPayload } from '@Utils/document-upload/document-upload';

const ManualDocumentUpload = (props: IManualDocumentUpload): React.ReactElement => {
  const {
    getIndividualDocumentsUploadList,
    dispatch,
    handleSubmit,
    getAllformVal,
    getAllRfiFormVal,
    activateLoader,
    countryCode,
    nationality,
    disableLoader,
    remitterDetails,
    documentDetails,
    document_status,
    isSgKycRfi,
    isSgKycPoaUploadPage,
    sgKycDocumentList
  } = props;
  const [cmsData, setCMSData] = useState<any>({});
  const [docList, setDocList] = useState<any[]>([]);
  const [documentCodeSelected, setDocumentCodeSelected] = useState<string>('');
  const [files, setFiles] = useState<FileList | null>();
  const [frontFiles, setFrontFiles] = useState<FileList | null>();
  const [backFiles, setBackFiles] = useState<FileList | null>();
  const [frontImgCapture, setFrontImgCapture] = useState<File | null>();
  const [frontImgFile, setFrontImgFile] = useState<ImgFileType | null>();
  const [backImgCapture, setBackImgCapture] = useState<File | null>();
  const [backImgFile, setBackImgFile] = useState<ImgFileType | null>();
  const [fileErrorFlag, setFileErrorFlag] = useState<boolean>(false);
  const [fileErrors, setFilesError] = useState<FilesErrorTypes>({
    frontError: '',
    backError: ''
  });
  const [backNavigationFlag, setBackNavigationFlag] = useState(true);
  const contentCountryCode = getContentCountryCode(countryCode);
  const [currentSequence, setCurrentSequence] = useState<number>(0);
  const [USDocFlag, setUSDocFlag] = useState<any>({});
  const [labelSecondCharLowerFlag, setLabelSecondCharLowerFlag] = useState<boolean>(false);
  const [cmsLabels, setCmsLabels] = useState<any>();
  const [isCaptureAvailable, setIsCaptureAvailable] = useState<boolean>(false);
  const [isBackRequired, setIsBackRequired] = useState<boolean>(false);
  const sgKycFlowData = useSelector(getSgkycFlowRfiData);
  const selectedFlowType = sgKycFlowData?.selectedFlowType;
  const isSingPassFlow = selectedFlowType === SG_ODD_FLOW_TYPES.SINGPASS;

  const getRequiredDocList = async () => {
    const docList = isSgKycRfi ? sgKycDocumentList : await getIndividualDocumentsUploadList(true);
    // Segregate the flow for the US
    if (docList && countryCode === US) {
      let POIFlag = null;
      let POAFlag = null;
      if (document_status) {
        document_status.forEach((item: any) => {
          if (item.type === 'INDIVIDUAL_POI') {
            POIFlag = item.status;
          } else if (item.type === 'INDIVIDUAL_POA') {
            POAFlag = item.status;
          }
        });
        setUSDocFlag({ POIFlag, POAFlag });
      }
      const filteredDocListUS: any[] = getFilteredDocListUS(docList);
      const filteredDocList = getFilteredDocList(
        filteredDocListUS[currentSequence],
        countryCode,
        nationality
      );
      setDocList(filteredDocList);
      setDocumentCodeSelected(filteredDocList[0]?.documentCode);
    } else if (docList) {
      const filteredDocList = getFilteredDocList(docList, countryCode, nationality, isSgKycRfi);
      if (filteredDocList) {
        setDocList(filteredDocList);
        setDocumentCodeSelected(filteredDocList[0]?.documentCode);
      }
    }
  };

  const getCMSData = async () => {
    const cmsDataResponse = await getContentSchemaFromContentFul(
      'pageJsonDataView',
      'MANUAL_DOCUMENT_UPLOAD'
    );
    const cmsDataRes = CorridorSpecificCMSData(cmsDataResponse, contentCountryCode);
    const labels = cmsDataRes?.data;
    setCmsLabels(labels);
    if (countryCode === US) {
      setCMSData({
        header: currentSequence
          ? labels?.header
          : labels?.ssnVerificationHeading || uploadConstants.header,
        subHeader: currentSequence
          ? labels?.subHeader
          : labels?.ssnDescription || uploadConstants.subHeader,
        submitCTA: labels?.submitCTA || uploadConstants.submitCTA,
        frontLabel: labels?.frontLabel || uploadConstants.frontLabel,
        backLabel: labels?.backLabel || uploadConstants.backLabel,
        myPassportHeading: labels?.passportHeading || uploadConstants.myPassportHeading,
        documentUploadInstruction:
          labels?.documentUploadInstruction || uploadConstants.documentUploadInstruction,
        documentUploadInstructionNationalID:
          labels?.documentUploadInstructionNationalID ||
          uploadConstants.documentUploadInstructionNationalID,
        passportInfoMsg: labels?.passportInfoMsg || uploadConstants.passportInfoMsg,
        viewSample: labels?.viewSample || uploadConstants.viewSample,
        passportSampleHeading:
          labels?.passportSampleHeading || uploadConstants.passportSampleHeading,
        passportSampleSubHeading:
          labels?.passportSampleSubHeading || uploadConstants.passportSampleSubHeading,
        passportSampleFooter: labels?.passportSampleFooter || uploadConstants.passportSampleFooter,
        passportSampleOKCTA: labels?.passportSampleOKCTA || uploadConstants.passportSampleOKCTA,
        ssnFormImgHeading: labels.ssnFormImgHeading || uploadConstants.ssnFormImgHeading,
        ssnUploadSubHeading: labels.ssnUploadSubHeading || uploadConstants.ssnUploadSubHeading,
        w2FormImgHeading: labels.w2FormImgHeading || uploadConstants.w2FormImgHeading,
        w2formUploadSubHeading:
          labels.w2formUploadSubHeading || uploadConstants.w2formUploadSubHeading,
        documentUploadInstructionDrivingLicense:
          labels?.documentUploadInstructionDrivingLicense ||
          uploadConstants.documentUploadInstructionDrivingLicense
      });
    } else {
      setCMSData({
        header: labels?.header || uploadConstants.header,
        subHeader: labels?.subHeader || uploadConstants.subHeader,
        submitCTA: labels?.submitCTA || uploadConstants.submitCTA,
        frontLabel: labels?.frontLabel || uploadConstants.frontLabel,
        backLabel: labels?.backLabel || uploadConstants.backLabel,
        myPassportHeading: labels?.passportHeading || uploadConstants.myPassportHeading,
        documentUploadInstruction:
          labels?.documentUploadInstruction || uploadConstants.documentUploadInstruction,
        documentUploadInstructionNationalID:
          labels?.documentUploadInstructionNationalID ||
          uploadConstants.documentUploadInstructionNationalID,
        passportInfoMsg: labels?.passportInfoMsg || uploadConstants.passportInfoMsg,
        viewSample: labels?.viewSample || uploadConstants.viewSample,
        passportSampleHeading:
          labels?.passportSampleHeading || uploadConstants.passportSampleHeading,
        passportSampleSubHeading:
          labels?.passportSampleSubHeading || uploadConstants.passportSampleSubHeading,
        passportSampleFooter: labels?.passportSampleFooter || uploadConstants.passportSampleFooter,
        passportSampleOKCTA: labels?.passportSampleOKCTA || uploadConstants.passportSampleOKCTA,
        documentUploadInstructionDrivingLicense:
          labels?.documentUploadInstructionDrivingLicense ||
          uploadConstants.documentUploadInstructionDrivingLicense
      });
    }
  };

  const configureFlags = () => {
    if (EU_REGION.includes(countryCode) || countryCode === US) {
      setBackNavigationFlag(false);
    }
  };

  useEffect(() => {
    const fetchCmsData = async () => {
      activateLoader();
      await getCMSData();
      configureFlags();
      disableLoader();
    };
    fetchCmsData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      activateLoader();
      await getRequiredDocList();
      disableLoader();
    };
    fetchData();
    //eslint-disable-next-line
  }, [currentSequence, isSgKycRfi]);

  const handleNavigateBack = () => {
    dispatch(changeOnBoardingScreen(REVAMPED_SCREENS.ekycServiceDown));
  };

  const resetFiles = () => {
    setFiles(null);
    setFrontFiles(null);
    setBackFiles(null);
    setFrontImgCapture(null);
    setBackImgCapture(null);
    setFrontImgFile(null);
    setBackImgFile(null);
  };

  const isFileUploadErrors = () => {
    if (documentCodeSelected === 'PASSPORT') {
      //@ts-ignore
      if (files?.length < 1 || !files) {
        setFileErrorFlag(true);
        return true;
      }
    } else if (documentCodeSelected === 'SSN_CARD') {
      //@ts-ignore
      if (frontFiles?.length < 1 || !frontFiles) {
        setFileErrorFlag(true);
        setFilesError({
          frontError: 'Required',
          backError: ''
        });
        return true;
      }
    } else if (documentCodeSelected === 'SSN_W2_FORM') {
      //@ts-ignore
      if (frontFiles?.length < 1 || !frontFiles) {
        setFileErrorFlag(true);
        setFilesError({
          frontError: 'Required',
          backError: ''
        });
        return true;
      }
    } else {
      const isFrontInvalid =
        !frontFiles || frontFiles.length < 1
          ? !isCaptureAvailable || (isCaptureAvailable && !frontImgCapture)
          : false;

      const isBackInvalid = isBackRequired
        ? !backFiles || backFiles.length < 1
          ? !isCaptureAvailable || (isCaptureAvailable && !backImgCapture)
          : false
        : false;

      if (isFrontInvalid && isBackInvalid) {
        setFilesError({
          frontError: 'Required',
          backError: 'Required'
        });
        return true;
      } else if (isFrontInvalid) {
        setFilesError({
          frontError: 'Required',
          backError: ''
        });
        return true;
      } else if (isBackInvalid) {
        setFilesError({
          frontError: '',
          backError: 'Required'
        });
        return true;
      }
    }
    return false;
  };

  const validateSgKycForm = () => {
    const reduxStore = store.getState();
    const uploadFormErrors =
      (reduxStore.form.uploadDocForm && (reduxStore.form.uploadDocForm as any).syncErrors) || {};
    const fileUploadErrors = isFileUploadErrors();
    // Manually ejecting form errors As UploadDoc form is used inside rfi form for SGKYC RFI Flow
    if (uploadFormErrors && Object.keys(uploadFormErrors).length > 0) {
      const uploadFieldNames = Object.keys(reduxStore.form.uploadDocForm.registeredFields || {});
      dispatch(touch(UPLOAD_DOC_FORM, ...uploadFieldNames));
      return true;
    }

    return fileUploadErrors;
  };

  const oddKycRfiSubmitHandler = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (validateSgKycForm()) {
      return;
    }
    activateLoader();
    const finalFirstFile = isCaptureAvailable ? frontFiles || frontImgCapture : frontFiles;
    const finalBackFile = isCaptureAvailable ? backFiles || backImgCapture : backFiles;
    submitSgKycRfi(getAllRfiFormVal, dispatch, { getAllformVal, finalFirstFile, finalBackFile });
  };
  const isPOARequired = document_status?.some(
    (item: any) => item.type === 'INDIVIDUAL_POA' && item.status === false
  );

  const submitDocuments = async () => {
    /*
      For Lithuania national who has done onfido,
      We need to take PIN from manualDoc Upload with no file rendered.
    */
    if (!remitterDetails?.onfido_check_created && isFileUploadErrors()) return;

    const finalFirstFile = isCaptureAvailable ? frontFiles || frontImgCapture : frontFiles;
    const finalBackFile = isCaptureAvailable ? backFiles || backImgCapture : backFiles;

    activateLoader();
    const submitResponse = await handleSubmitDocs(
      dispatch,
      documentCodeSelected,
      UPLOAD_DOC_FORM,
      getAllformVal,
      //@ts-ignore
      files,
      finalFirstFile,
      finalBackFile,
      countryCode,
      nationality,
      remitterDetails?.onfido_check_created
    );
    disableLoader();
    if (submitResponse) {
      logEvents();
      if (EU_REGION.includes(countryCode)) {
        //Check if user nationality is LT and onfido check is created for user(user has come from ekyc)
        if (nationality === 'LT' && remitterDetails?.onfido_check_created) {
          dispatch(changeOnBoardingScreen(REVAMPED_SCREENS.holdingVerifyScreen));
        } else {
          dispatch(
            changeOnBoardingScreen(
              isPOARequired ? REVAMPED_SCREENS.manualDocumentUpload : REVAMPED_SCREENS.selfieUpload
            )
          );
        }
      }
      if (countryCode === MY) {
        dispatch(changeOnBoardingScreen(REVAMPED_SCREENS.scheduleInterview));
      }
      if (countryCode === US) {
        resetFiles();
        await dispatch(reset(UPLOAD_DOC_FORM));
        if (currentSequence === 0 && USDocFlag?.POIFlag === false && USDocFlag?.POAFlag === null) {
          setCurrentSequence(1);
          setCMSData({
            ...cmsData,
            header: cmsLabels?.header || uploadConstants.header,
            subHeader: cmsLabels?.subHeader || uploadConstants.subHeader
          });
        } else if (
          (currentSequence === 1 && USDocFlag?.POIFlag === false && USDocFlag?.POAFlag === null) ||
          (USDocFlag?.POIFlag === null && USDocFlag?.POAFlag === false)
        ) {
          dispatch(changeOnBoardingScreen(REVAMPED_SCREENS.ekycAck));
        } else if (
          currentSequence === 1 &&
          USDocFlag?.POIFlag === false &&
          USDocFlag?.POAFlag === false
        ) {
          dispatch(changeOnBoardingScreen(REVAMPED_SCREENS.manualDocumentUpload));
        }
      }
    }
  };

  const handleSubmitDocsClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    activateLoader();

    try {
      const fileKey = `${sgKycDocumentList[0].type.toLowerCase()}_${sgKycDocumentList[0].document_code.toLowerCase()}_doc_file`;
      const payload = {
        [sgKycDocumentList[0]?.type]: {
          [sgKycDocumentList[0]?.document_code]: {
            ...getAllformVal,
            //@ts-ignore
            [fileKey]: frontFiles[0],
            //@ts-ignore
            ...(sgKycDocumentList[0].is_back_mandatory
              ? //@ts-ignore
                { [`${fileKey}_back`]: backFiles[0] }
              : {})
          }
        }
      };
      //ts ignore is required here because we are using only 3 params here and others are not required,
      // and if we modify existing params shape, modifying may mess up other implementations
      //Process the payload and files according to apis payload and then create an api request
      //@ts-ignore
      const { documents, files: processedFiles } = processSubmitPayload(payload, [], {});
      const response = await dispatch(
        uploadDocDetailsNew(
          processedFiles,
          documents,
          { formID: UPLOAD_DOC_FORM, payload, doc_count: frontFiles?.length },
          false,
          true
        )
      );
      //@ts-ignore
      if (response?.data?.success) {
        await oddKycRfiSubmitHandler(e);
      }
    } finally {
      disableLoader();
    }
  };

  const handleSubmitButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (isSingPassFlow) {
      handleSubmitDocsClick(e);
    } else {
      oddKycRfiSubmitHandler(e);
    }
  };

  useEffect(() => {
    if (countryCode === US && documentDetails?.length) {
      const isPassportDrivingLicenseUploadedFlag = documentDetails.some((ele: any) => {
        if (['SSN_W2_FORM', 'SSN_CARD'].includes(ele?.document_code)) {
          return true;
        }
        return false;
      });
      setCurrentSequence(isPassportDrivingLicenseUploadedFlag ? 1 : 0);
    }
    if (countryCode === US) {
      setLabelSecondCharLowerFlag(true);
    }
    // eslint-disable-next-line
  }, [documentDetails]);

  useEffect(() => {
    // Settig this up to change header and subheading for US when current sequence changes and cmsData is there.
    if (currentSequence && Object.keys(cmsData).length) {
      setCMSData({
        ...cmsData,
        header: cmsLabels?.header || uploadConstants.header,
        subHeader: cmsLabels?.subHeader || uploadConstants.subHeader
      });
    }
    // eslint-disable-next-line
  }, [currentSequence, cmsData]);

  return (
    <ParentContainer padding={[-2, 0]} isSgKycRfi={isSgKycRfi}>
      {backNavigationFlag && !isSgKycRfi && (
        <div className="navigation-container">
          <img
            onClick={handleNavigateBack}
            className="back-button"
            src={CHEVRON_LEFT_ICON}
            alt="back"
          />
        </div>
      )}
      {isSgKycRfi && !isSgKycPoaUploadPage && docList?.length === 1 ? (
        <RFIUploadHeaderContainer>
          <RFIUploadHeader>{docList?.[0]?.label || ''}</RFIUploadHeader>
          <RFIUploadSubHeader>{`Please enter your ${
            docList?.[0]?.label || ''
          } details`}</RFIUploadSubHeader>
        </RFIUploadHeaderContainer>
      ) : null}
      {!isSgKycRfi ? (
        <SubContainer>
          <Header>{cmsData?.header}</Header>
          <SubHeader>{cmsData?.subHeader}</SubHeader>
        </SubContainer>
      ) : null}

      <FormContainer
        marginTop={42}
        isSgKycRfi={isSgKycRfi}
        onSubmit={handleSubmit(submitDocuments)}
      >
        <form>
          <ManualDocumentFields
            docList={docList}
            dispatch={dispatch}
            files={files}
            setFiles={setFiles}
            frontFiles={frontFiles}
            setFrontFiles={setFrontFiles}
            backFiles={backFiles}
            setBackFiles={setBackFiles}
            setFrontImgCapture={setFrontImgCapture}
            setBackImgCapture={setBackImgCapture}
            frontImgFile={frontImgFile}
            setFrontImgFile={setFrontImgFile}
            backImgFile={backImgFile}
            setBackImgFile={setBackImgFile}
            setIsCaptureAvailable={setIsCaptureAvailable}
            setIsBackRequired={setIsBackRequired}
            setDocumentCodeSelected={setDocumentCodeSelected}
            fileErrorFlag={fileErrorFlag}
            fileErrors={fileErrors}
            setFilesError={setFilesError}
            resetFiles={resetFiles}
            cmsData={cmsData}
            labelSecondCharLowerFlag={labelSecondCharLowerFlag}
            countryCode={countryCode}
          />
          {!isSgKycRfi ? (
            <Row padding={[48, 0, 24, 0]}>
              <Col width={450}>
                <CommonButton text={cmsData?.submitCTA} width={450} />
              </Col>
            </Row>
          ) : null}
          {isSgKycRfi ? (
            <Row isSgKycRfi={isSgKycRfi} padding={[48, 0, 24, 0]}>
              <CommonButton
                text={cmsData?.submitCTA}
                width={250}
                onClick={handleSubmitButtonClick}
              />
            </Row>
          ) : null}
        </form>
      </FormContainer>
    </ParentContainer>
  );
};

const createReduxForm = reduxForm({
  form: UPLOAD_DOC_FORM,
  onSubmitFail: scrollToError
});

function mapStateToProps(reduxState: any) {
  const {
    rootReducer: {
      userStatusReducer: { country_code: countryCode, nationality, document_status },
      userDataReducer: {
        userStateInfo: { remitterDetails }
      },
      documentDataReducer: { documentDetails }
    }
  } = reduxState;

  const getAllformVal = getFormValues(UPLOAD_DOC_FORM)(reduxState);
  const getAllRfiFormVal = getFormValues(FORMNAME_RFI)(reduxState);
  return {
    getAllformVal,
    getAllRfiFormVal,
    countryCode,
    nationality,
    remitterDetails,
    documentDetails,
    document_status
  };
}

export default connect(mapStateToProps, {
  getIndividualDocumentsUploadList,
  activateLoader,
  disableLoader
})(createReduxForm(ManualDocumentUpload));
